// Historical serviceline trending data, served per-entity from the shared
// S3/CloudFront tree at data.doctivityhealth.com (all environments — the
// bucket is keyed only by cross-environment identifiers; see
// doctivity-rest/docs/data/historical-data.md).
//
// These are plain actions handled by trendingSaga (not redux-saga-requests):
// the bytes come from CloudFront with signed cookies, not from the REST API,
// so the shared axios driver (auth header, selected_client_id param) must not
// touch these requests.

export const TRENDING_DATA_LOAD = 'TRENDING_DATA_LOAD';
export const TRENDING_DATA_LOADING = 'TRENDING_DATA_LOADING';
export const TRENDING_DATA_SUCCESS = 'TRENDING_DATA_SUCCESS';
export const TRENDING_DATA_ERROR = 'TRENDING_DATA_ERROR';
export const TRENDING_ACCESS_SUCCESS = 'TRENDING_ACCESS_SUCCESS';

// entityType values match the top-level directories of the data tree
export const TrendingEntityType = {
  PROVIDER: 'providers',
  ORGANIZATION: 'organizations',
};

// dataType -> file within an entity's <year>/Q<q>/ directory
export const TrendingDataType = {
  PROJECTED_PATIENTS: 'projected_patients',
  PEDIATRIC_PROJECTED_PATIENTS: 'pediatric_projected_patients',
  CAPTURED_CLAIMS: 'captured_claims',
  PATIENT_MIGRATION: 'patient_migration',
  // shared-patient network edges (providers tree only)
  SHARED_AFTER: 'shared_after',
  SHARED_BEFORE: 'shared_before',
};

// One cache key per fetched file
export const trendingKey = (entityType, id, year, quarter, dataType) =>
  `${entityType}:${id}:${year}:Q${quarter}:${dataType}`;

/**
 * Load one quarter of one data type for one entity.
 * @param entityType TrendingEntityType (providers | organizations)
 * @param id         the entity's NPI, or its LexisNexis claims id when it has
 *                   no NPI (POZ… / PIZ… — the tree is keyed the same way)
 * @param year       measurement year (e.g. 2025)
 * @param quarter    measurement quarter 1-4
 * @param dataType   TrendingDataType
 */
export const loadTrendingData = (entityType, id, year, quarter, dataType) => ({
  type: TRENDING_DATA_LOAD,
  entityType,
  id,
  year,
  quarter,
  dataType,
});

// ---- affiliated-NPI set --------------------------------------------------
// The S3 shared-* files carry only NPIs; affiliation is client DB data. One
// query per client fetches every affiliated provider's NPI, the reducer keeps
// it as a per-client cache, and edge rows resolve with a Set lookup — no
// per-row/API round trips.

export const TRENDING_AFFILIATED_LOAD = 'TRENDING_AFFILIATED_LOAD';
export const TRENDING_AFFILIATED_LOADING = 'TRENDING_AFFILIATED_LOADING';
export const TRENDING_AFFILIATED_SUCCESS = 'TRENDING_AFFILIATED_SUCCESS';
export const TRENDING_AFFILIATED_ERROR = 'TRENDING_AFFILIATED_ERROR';

export const loadAffiliatedNpis = (clientId) => ({
  type: TRENDING_AFFILIATED_LOAD,
  clientId,
});
